import * as React from 'react';
import { ClassNames } from '@emotion/react';
import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { tabIconWrapper, tabLabelIcon, tabRoot, tabSelected } from './tabCssDefs';

export interface TabProps extends MuiTabProps {
  component?: React.ElementType;
  to?: string;
}

/**
 * A styled Tabs component. The contained prop will render a bottom border
 * [Material ui Tab](https://mui.com/api/tab/)
 *
 * ```js
 * import { Tab } from 'ui';
 * ```
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Tab: React.FunctionComponent<React.PropsWithChildren<TabProps>> = (props) => {
  return (
    <ClassNames>
      {({ css, theme }) => (
        <MuiTab
          classes={{
            root: css(tabRoot(theme)),
            selected: css(tabSelected(theme)),
            iconWrapper: css(tabIconWrapper()),
            labelIcon: css(tabLabelIcon(theme)),
          }}
          {...props}
        />
      )}
    </ClassNames>
  );
};

export default Tab;
